import React from 'react';
import PropTypes from 'prop-types';
import {
  textColorPicker,
  stringTextAreaSpec,
  boolCheckboxSpec,
  subtitleInput,
  stringInputSpec,
  repeatable,
} from '../../lib/editing-configs';

import BackgroundColor from '../background-color/background-color';
import LogoSalad from './logo-salad';

const LOGO_PATH = 'https://www.nerdwallet.com/cdn/img/landing/logos/';

const logosParsed = (logos) =>
  logos.map(({ src, alt }) => ({
    alt,
    src: `${LOGO_PATH}${src}`,
  }));

const EditableLogoSalad = ({ desktopLogos, mobileLogos, ...props }) => (
  <LogoSalad
    desktopLogos={logosParsed(desktopLogos)}
    mobileLogos={mobileLogos && logosParsed(mobileLogos)}
    {...props}
  />
);

const Logo = PropTypes.shape({
  scr: PropTypes.string,
  alt: PropTypes.string,
});

EditableLogoSalad.propTypes = {
  desktopLogos: PropTypes.arrayOf(Logo),
  mobileLogos: PropTypes.arrayOf(Logo),
  ...BackgroundColor.propTypes,
};

EditableLogoSalad.defaultProps = {
  desktopLogos: [],
  ...BackgroundColor.defaultProps,
};

EditableLogoSalad.getEditingConfig = (componentDocument) => [
  ...BackgroundColor.getEditingConfig(componentDocument),
  textColorPicker,
  stringTextAreaSpec('title', 'Title', {
    help: 'For a smaller size title, surround title text with | like |this|.',
  }),
  subtitleInput,
  boolCheckboxSpec('bigLogos', 'Increase the logos size (Desktop)'),
  repeatable('desktopLogos', 'Desktop Logos', 'Logo', () => [
    stringInputSpec('alt', 'Alt Text'),
    stringInputSpec('src', 'URL'),
  ]),
  repeatable('mobileLogos', 'Mobile Logos', 'Logo', () => [
    stringInputSpec('alt', 'Alt Text'),
    stringInputSpec('src', 'URL'),
  ]),
];

EditableLogoSalad.displayName = 'EditableLogoSalad';

export default EditableLogoSalad;
